import React from "react";

export default function Cart() {
    return (
        <div className="cart"></div>
    )
}